"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _UrlPicker = _interopRequireDefault(require("./UrlPicker"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
var _PasscodePrompt = _interopRequireDefault(require("./PasscodePrompt"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var UrlConfig = /*#__PURE__*/function (_React$Component) {
  _inherits(UrlConfig, _React$Component);
  var _super = _createSuper(UrlConfig);
  function UrlConfig() {
    _classCallCheck(this, UrlConfig);
    return _super.apply(this, arguments);
  }
  _createClass(UrlConfig, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props$fields = this.props.fields,
        respondentConfig = _this$props$fields.respondentConfig,
        requireLogin = _this$props$fields.requireLogin;
      if (respondentConfig.value !== 'managed' && requireLogin.value === true) {
        requireLogin.onChange(false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$fields2 = this.props.fields,
        individualPasscode = _this$props$fields2.individualPasscode,
        passcodeBackground = _this$props$fields2.passcodeBackground,
        passcodeBackgroundColor = _this$props$fields2.passcodeBackgroundColor,
        passcodeCompletionButtonText = _this$props$fields2.passcodeCompletionButtonText,
        passcodeLabel = _this$props$fields2.passcodeLabel,
        requireLogin = _this$props$fields2.requireLogin,
        respondentConfig = _this$props$fields2.respondentConfig;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: requireLogin,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "How will respondents access the Quest?",
          tooltip: "You can modify the link by checking the box for 'Use custom URL'. For certain user types you can also choose to provide one link all respondents access or generate unique links for each respondent."
        })
      }, respondentConfig.value === 'managed' && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "radio",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
        onChange: function onChange() {
          return requireLogin.onChange(false);
        },
        checked: !requireLogin.value,
        type: "radio",
        value: "personal"
      }), "Each respondent will receive a personal URL (no login)")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "radio"
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
        onChange: function onChange() {
          return requireLogin.onChange(true);
        },
        checked: requireLogin.value,
        type: "radio",
        value: "login"
      }), "Respondents will login via a single URL")))), respondentConfig.value === 'manual' && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '-1em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: individualPasscode
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "radio"
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
        checked: !individualPasscode.value,
        onChange: function onChange() {
          individualPasscode.onChange(false);
        },
        type: "radio",
        value: !individualPasscode.value
      }), "Respondents will receive a personal URL (no passcode)")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "radio"
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
        checked: individualPasscode.value,
        onChange: function onChange() {
          individualPasscode.onChange(true);

          // initialize these settings for older Deployments that
          // were created before these settings existed
          if (!passcodeBackground.value) {
            passcodeBackground.onChange('solidColor');
          }
          if (!passcodeBackgroundColor.value) {
            passcodeBackgroundColor.onChange('#F1F0F5');
          }
          if (!passcodeCompletionButtonText.value) {
            passcodeCompletionButtonText.onChange('Ok');
          }
          if (!passcodeLabel.value) {
            passcodeLabel.onChange('Your Passcode');
          }
        },
        type: "radio",
        value: individualPasscode.value
      }), "Respondents will enter a passcode at a single URL"))), individualPasscode.value === true && /*#__PURE__*/_react["default"].createElement(_PasscodePrompt["default"], {
        fields: this.props.fields
      })), (respondentConfig.value === 'anonymous' || respondentConfig.value === 'manual' && !!individualPasscode.value || respondentConfig.value === 'managed' && !!requireLogin.value) && /*#__PURE__*/_react["default"].createElement("div", {
        style: respondentConfig.value === 'manual' ? {
          marginLeft: '2em'
        } : {}
      }, /*#__PURE__*/_react["default"].createElement(_UrlPicker["default"], {
        fields: this.props.fields
      })), respondentConfig.value === 'previous' && /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          position: 'relative',
          top: '-10px'
        }
      }, /*#__PURE__*/_react["default"].createElement("i", null, "You will be able to edit this later after saving this Data Collection Wave.")));
    }
  }]);
  return UrlConfig;
}(_react["default"].Component);
exports["default"] = UrlConfig;
_defineProperty(UrlConfig, "propTypes", {
  fields: _propTypes["default"].object
});